/**
 * Parse an array value from a string
 * @param value - The string to parse
 * @returns The array value
 */
export const parseArray = (value: string): string[] => {
  return value.split(",").filter(Boolean);
};
